import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from 'react-parallax';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import NoticiasListar from '../section-pages/noticias-listar'; 
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiNoticias from '../services/noticiaService';

const image1 = '../../img/background/bg-grid.webp';

export default function Home() {
  const [noticias, setNoticias] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchNoticias = async () => {
    try {
      const response = await ApiNoticias.listar();
      setNoticias(response.data);
    } catch (error) {
      console.error('Erro ao buscar notícias:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }

    fetchNoticias();
  }, []);

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        {/* Banner */}
        <section className="no-bg">
        <div>
          <img src="../../img/background/bg-header.png" width="100%"/>
        </div>
        <div className="container z-9">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <center>
                <h3 className="titulo">NOTÍCIAS</h3>
              </center>
            </div>        
          </div>
        </div>
      </section>

        {/* Conteúdo */}
        <section>
          {isLoading ? (
            <div className="loading">Carregando notícias...</div>
          ) : (
            <NoticiasListar noticias={noticias} />
          )}
        </section>

        {/* Footer */}
        <Footer />
      </div>

      <ScrollToTopBtn />
    </>
  );
}
